import UserCard, { type UserCardItem } from "./UserCard";

type UserGridProps = {
  users: UserCardItem[];
};

export default function UserGrid({ users }: UserGridProps) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3">
      {users.map((user) => (
        <UserCard key={user.id} user={user} />
      ))}
    </div>
  );
}
